<template>
    <div class="bg-white relative z-0">
        <div class="page-container">
            <div class="px-8 md:px-5 py-5 ">
                <h1 class="mb-6">
                    Where do I find my Serial number?
                </h1>

                <p class="mb-6">
                    <router-link :to="{ name: 'autologin' }" class="btn">
                        Go Back
                    </router-link>
                </p>

                <p class="mb-2">
                    My machine looks something like this, with a touch screen panel.
                </p>
                <p class="mb-6">
                    <img src="../assets/sharp-example4.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    On screen touch the Settings Button
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example5.jpg" alt="How to find Serial Number"/>
                </p>


                <p class="mb-2">
                    If the display looks like this, the serial number is displayed on the top page
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example6.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    If the display looks like this, select Status to see the serial number
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example7.jpg" alt="How to find Serial Number" class="mb-2"/>
                    <img src="../assets/sharp-example8.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    If your machine doesn’t have a full touch screen and looks more like this:
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example9.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    Push the System Settings button, it may be labelled System Settings or look like this:
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example10.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    In the touch panel select List Print (User)
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example11.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    Print All Custom Settings List:
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example12.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mb-2">
                    A few pages will print, the Serial number is printed on the top right of each page:
                </p>

                <p class="mb-6">
                    <img src="../assets/sharp-example13.jpg" alt="How to find Serial Number"/>
                </p>

                <p class="mt-8">
                    <router-link :to="{ name: 'autologin' }" class="btn">
                        Go Back
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

